import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import CampaignIcon from '@mui/icons-material/Campaign';

const NOTICES_API = 'https://system.sales-management.cloud/api/notices.php';

function Notices() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchNotices = async () => {
      setLoading(true);
      setError('');

      try {
        const token = Cookies.get('auth_token');
        if (!token) {
          setError('認証情報が見つかりません');
          return;
        }

        const response = await fetch(`${NOTICES_API}?limit=20`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const result = await response.json();
        if (result.status === 'success') {
          setNotices(result.data?.notices || []);
        } else {
          setError(result.message || 'お知らせの取得に失敗しました');
        }
      } catch (err) {
        console.error('Notices fetch error:', err);
        setError('通信エラーが発生しました');
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6">
      <div className="flex items-center gap-2 mb-6">
        <CampaignIcon className="text-blue-600" />
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">お知らせ</h1>
      </div>

      {loading ? (
        <div className="flex justify-center items-center min-h-[240px]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
        </div>
      ) : error ? (
        <div className="bg-red-50 border border-red-200 rounded-md p-4">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      ) : notices.length === 0 ? (
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-sm text-gray-500">現在お知らせはありません</p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
          <div className="space-y-3">
            {notices.map((notice) => (
              <div key={notice.id} className="bg-gray-50 rounded-md px-3 py-3">
                <p className="text-base font-semibold text-gray-900">{notice.title}</p>
                <p className="text-sm text-gray-700 mt-1 whitespace-pre-wrap">{notice.message}</p>
                <p className="text-xs text-gray-500 mt-2">
                  有効期限: {notice.expires_at ? new Date(notice.expires_at).toLocaleString('ja-JP') : '無期限'}
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  {new Date(notice.created_at).toLocaleString('ja-JP')}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Notices;